import type { ContestRequest, SimRunResponse } from '../../types/electionSim'
import type { Levers } from './LeverPanel'

/** Compact, log-friendly summary of the selected contest (semantic 'contest' mark). */
export function contestMarkDetail(contest: ContestRequest): Record<string, unknown> {
  const c = contest as ContestRequest & { chamber?: string }
  return {
    type: c.type,
    office: c.office ?? null,
    state: c.state ?? null,
    districtGeoUnitId: c.districtGeoUnitId ?? null,
    chamber: c.chamber ?? null,
  }
}

/**
 * Everything a reviewer needs to reconstruct a simulation run (semantic 'run' mark):
 * the full contest + lever state that produced it, plus the outcome the tester saw.
 * Per the design decision, sliders are NOT marked individually — this run mark holds
 * the whole lever state instead. Allocation is included only for chamber contests.
 */
export function runMarkDetail(
  contest: ContestRequest,
  levers: Levers,
  allocation: Record<string, number>,
  run: SimRunResponse,
): Record<string, unknown> {
  const detail: Record<string, unknown> = {
    contest: contestMarkDetail(contest),
    levers,
    outcome: {
      coverage: run.coverage,
      winProbability: run.winProbability,
      baselineWinProbability: run.baselineWinProbability,
      votesNeeded: run.votesNeeded,
      totalContacts: run.totalContacts,
      chamberMajorityProbability: run.chamber?.majorityProbability ?? null,
      chamberMedianSeats: run.chamber?.medianSeats ?? null,
    },
  }
  if (contest.type === 'chamber') detail.allocation = allocation
  return detail
}
